import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4011';

export interface ConversationPrompt {
  id: string;
  question: string;
  category: string;
  difficulty: number;
  isPremium: boolean;
  usageCount?: number;
}

export interface PromptResponse {
  prompt: ConversationPrompt | null;
  message: string;
}

export interface AllPromptsResponse {
  prompts: ConversationPrompt[];
  isPremium: boolean;
  message: string;
}

export class PromptsService {
  /**
   * Get today's daily conversation prompt
   */
  static async getDailyPrompt(accessToken: string): Promise<PromptResponse> {
    const response = await axios.get(`${API_URL}/prompts/daily`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  }

  /**
   * Get a random conversation prompt
   * Optional filters: category, difficulty
   */
  static async getRandomPrompt(
    accessToken: string,
    category?: string,
    difficulty?: number,
  ): Promise<PromptResponse> {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (difficulty) params.append('difficulty', difficulty.toString());

    const response = await axios.get(
      `${API_URL}/prompts/random?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return response.data;
  }

  /**
   * Get all active conversation prompts
   */
  static async getAllPrompts(
    accessToken: string,
  ): Promise<AllPromptsResponse> {
    const response = await axios.get(`${API_URL}/prompts`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  }

  /**
   * Seed prompts (development only)
   */
  static async seedPrompts(): Promise<any> {
    const response = await axios.post(`${API_URL}/prompts/seed`);
    return response.data;
  }
}

export default PromptsService;
